"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ForcedBet = void 0;
/**
 * ForcedBet.ts
 *
 * Enum for all the supported forced bets (a bet you have to make to play in a game before the
 * cards are even dealt). Current support is for Ante (everyone pays the same amount) and Blinds
 * a couple of players pay a smallBlind and bigBlind and the rest of the players decide if they
 * want to be in the game or not.
 */
//
var ForcedBet;
(function (ForcedBet) {
    ForcedBet[ForcedBet["BLINDS"] = 1] = "BLINDS";
    ForcedBet[ForcedBet["ANTES"] = 2] = "ANTES";
})(ForcedBet || (exports.ForcedBet = ForcedBet = {}));
//# sourceMappingURL=ForcedBet.js.map